import { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { BookOpen } from "@phosphor-icons/react";
import SurahSearch from "./SurahSearch";
import PageTitle from "../../components/ui/PageTitle";

type Surah = { number: number; name: string };

export default function SurahListPage() {
  const [surahs, setSurahs] = useState<Surah[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://api.alquran.cloud/v1/surah")
      .then((res) => res.json())
      .then((data) => { setSurahs(data.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <GradientBg>
      <Container>
        <PageTitle
          icon={<BookOpen size={24} weight="duotone" style={{ marginInlineEnd: 8 }} color="var(--primary)" />}
          center gap={8} as="h1"
        >
          فهرس السور
        </PageTitle>

        <Subtitle>اختر سورة للانتقال إلى صفحة المصحف</Subtitle>

        {!loading && <SurahSearch surahs={surahs} />}

        {loading ? (
          <Loader>جارٍ التحميل...</Loader>
        ) : (
          <Grid>
            {surahs.map((s) => (
              <Card key={s.number} to={`/surah/${s.number}`}>
                <Badge>{s.number}</Badge>
                <Name>{s.name}</Name>
                <CardOverlay />
              </Card>
            ))}
          </Grid>
        )}
      </Container>
    </GradientBg>
  );
}

/* --- styles --- */
const GradientBg = styled.div`
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;
const Container = styled.div`
  padding-top: 20px;
  padding-inline: clamp(16px, 4vw, 32px);
  flex: 1;
`;
const Subtitle = styled.p`
  text-align: center; margin: 6px 0 24px; font-size: .95rem; font-weight: 300; color: var(--muted);
`;
const Loader = styled.div` text-align: center; padding: 40px; font-size: 1.1rem; `;
const Grid = styled.div`
  display: grid; gap: 16px;
  grid-template-columns: repeat(2, 1fr);
  @media (min-width:640px){ grid-template-columns: repeat(3, 1fr); }
  @media (min-width:1024px){ grid-template-columns: repeat(4, 1fr); }
`;
const Card = styled(Link)`
  position: relative; display:flex; align-items:center; justify-content:center;
  height:100px; border-radius:16px; background:var(--surface); box-shadow:var(--shadow);
  text-decoration:none; overflow:hidden; transition: transform .15s ease, box-shadow .15s ease;
  &:hover { transform: translateY(-3px); box-shadow:0 12px 20px rgba(0,0,0,.15); }
`;
const Badge = styled.span`
  position:absolute; top:10px; right:10px;
  background:var(--primary); color:#fff; font-weight:600; font-size:.9rem;
  padding:4px 8px; border-radius:12px;
`;
const Name = styled.span`
  font-size:2.5rem; font-family:"Lateef","Scheherazade",system-ui; font-weight:500; color:var(--text); text-align:center; z-index:1;
`;
const CardOverlay = styled.div`
  position:absolute; left:0; right:0; bottom:0; height:28px;
  background: linear-gradient(to top, rgba(0,0,0,.05), transparent);
`;
